import { UI } from "@wwimmo/ui";
import { useCallback, useContext } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import styles from "./CancelInvoiceModal.module.css";
import { RestartCancelInvoiceProgress } from "src/screens/creditors/creditor/details/actions/restartInvoice/progress/RestartCancelInvoiceProgress";
import {
    RESTART_CANCEL_INVOICE_STATE,
    RESTART_CANCEL_MODAL_TYPE
} from "src/stores/krediflow/RestartCancelInvoiceStore";

const CancelInvoiceModalBase = () => {
    const { t } = useTranslation();
    const { restartCancelInvoiceStore, invoiceListStore, invoiceStore } = useContext(RootStoreContext);

    const toggleDisplayAssignInvoiceModal = useCallback(() => {
        const modalIsBeingClosed = restartCancelInvoiceStore.isModalDisplayed;

        restartCancelInvoiceStore.setIsModalDisplayed(!restartCancelInvoiceStore.isModalDisplayed);

        if (modalIsBeingClosed) {
            if (modalIsBeingClosed) {
                if (
                    restartCancelInvoiceStore.restartCancelInvoiceState === RESTART_CANCEL_INVOICE_STATE.FINISHED &&
                    invoiceListStore.isBatchProcessing
                ) {
                    invoiceListStore.navigateToNextBatchProcess();
                }

                restartCancelInvoiceStore.reset();
            }

            restartCancelInvoiceStore.reset();
        }
    }, [restartCancelInvoiceStore, invoiceListStore]);

    const onClickCancel = useCallback(() => {
        const currentInvoiceId = invoiceStore.currentInvoice?.id;
        const currentWorkflowId = invoiceStore.currentInvoice?.workflowInstance;

        if (currentInvoiceId && currentWorkflowId) {
            restartCancelInvoiceStore.cancelInvoice(currentInvoiceId, currentWorkflowId, false);
        }
    }, [restartCancelInvoiceStore, invoiceStore]);

    return (
        <UI.Modal
            title={t("screens.kredi_flow.action.cancel").toString()}
            size="lg"
            show={
                restartCancelInvoiceStore.isModalDisplayed &&
                restartCancelInvoiceStore.displayedModalType === RESTART_CANCEL_MODAL_TYPE.CANCEL
            }
            onClose={toggleDisplayAssignInvoiceModal}
            centered={true}
        >
            {restartCancelInvoiceStore.restartCancelInvoiceState === RESTART_CANCEL_INVOICE_STATE.INIT ? (
                <>
                    <UI.Row className={"mt-2"}>
                        <UI.Col sm={12}>
                            <div className="mt-2 mb-4">
                                {t("screens.kredi_flow.action.cancel_invoice.confirm_question")}
                            </div>
                        </UI.Col>
                    </UI.Row>
                    <UI.Row>
                        <UI.Col>
                            <UI.Button
                                label={t("labels.cancel").toString()}
                                className={`mb-2 ${styles.CancelButton}`}
                                onClick={toggleDisplayAssignInvoiceModal}
                                variant="outline-primary"
                            />
                        </UI.Col>
                        <UI.Col>
                            <UI.Button
                                label={t("screens.kredi_flow.action.cancel").toString()}
                                className={`mb-2 ml-auto ${styles.SubmitButton}`}
                                onClick={onClickCancel}
                            />
                        </UI.Col>
                    </UI.Row>
                </>
            ) : undefined}

            {restartCancelInvoiceStore.restartCancelInvoiceState === RESTART_CANCEL_INVOICE_STATE.RESTARTING ||
            restartCancelInvoiceStore.restartCancelInvoiceState === RESTART_CANCEL_INVOICE_STATE.CANCELLING ||
            restartCancelInvoiceStore.restartCancelInvoiceState === RESTART_CANCEL_INVOICE_STATE.FINISHED ? (
                <RestartCancelInvoiceProgress
                    key={"approve-reject-invoice-progress-assigning"}
                    currentRestartInvoiceState={restartCancelInvoiceStore.restartCancelInvoiceState}
                />
            ) : undefined}
        </UI.Modal>
    );
};

export const CancelInvoiceModal = Sentry.withProfiler(observer(CancelInvoiceModalBase));
